<template>
  <BaseModal
    v-if="isShowing"
    color="grey"
    rounded
    dropShadow
    class="dataset-upload-warning-dialog"
  >
    <div class="dataset-upload-warning-dialog__container">
      <template v-if="hasFutureDataPoints && hasZeroDataPoints">
        <header class="dataset-upload-warning-dialog__header">
          <h1 class="dataset-upload-warning-dialog__title">
            Some of the entries in your submission require attention.
          </h1>
        </header>
        <section class="dataset-upload-warning-dialog__body">
          <ul class="dataset-upload-warning-dialog__body-list">
            <li>
              The following months have "0" listed in your excel sheet:
              <span class="italic">
                {{
                  zeroDataPoints
                    .map((dataPoint) => {
                      return dataPoint.MonthYear;
                    })
                    .join(', ')
                }}
              </span>
              .
            </li>
            <li>Some entries list future months.</li>
          </ul>
          <p>
            If this was intentional, you may continue with submitting your
            Dataset Request. If any of this was not intentional, please edit
            your excel file and reupload.
          </p>
        </section>
      </template>
      <template v-else-if="hasFutureDataPoints">
        <header class="dataset-upload-warning-dialog__header">
          <h1 class="dataset-upload-warning-dialog__title">
            We found data entries listed in future months of your submission.
          </h1>
        </header>
        <section class="dataset-upload-warning-dialog__body">
          <p>
            If this was intentional, please be sure to include the reasoning
            behind this inclusion in the "notes" section of your submission.
          </p>
          <p>
            If this was not intentional, please edit your excel file and
            reupload.
          </p>
        </section>
      </template>
      <template v-else-if="hasZeroDataPoints">
        <header class="dataset-upload-warning-dialog__header">
          <h1 class="dataset-upload-warning-dialog__title">
            We found zeroes in some of the fields of your submission.
          </h1>
        </header>
        <section class="dataset-upload-warning-dialog__body">
          <p>
            The following months have "0" listed in your excel sheet:
            <span class="italic">
              {{
                zeroDataPoints
                  .map((dataPoint) => {
                    return dataPoint.MonthYear;
                  })
                  .join(', ')
              }}
            </span>
            .
          </p>
          <p>
            If this was intentional, you may continue with submitting your
            Dataset Request. If this was not intentional, please edit your excel
            file and reupload.
          </p>
        </section>
      </template>
      <footer class="dataset-upload-warning-dialog__footer">
        <button
          type="button"
          class="dataset-upload-warning-dialog__button dataset-upload-warning-dialog__button--confirm"
          @click="__confirm()"
        >
          OKAY
        </button>
      </footer>
    </div>
  </BaseModal>
</template>

<script>
  import BaseModal from '~/components/base/BaseModal.vue';

  export default {
    name: 'DatasetUploadWarningDialog',
    components: {
      BaseModal,
    },
    props: {
      size: {
        type: String,
        required: false,
        default: 'md',
        validator: (value) => {
          const SIZES = ['sm', 'md', 'lg'];
          return SIZES.includes(value);
        },
      },
    },
    data: () => ({
      isShowing: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
      futureDataPoints: [],
      zeroDataPoints: [],
    }),
    computed: {
      hasFutureDataPoints() {
        return this.futureDataPoints && this.futureDataPoints.length > 0;
      },
      hasZeroDataPoints() {
        return this.zeroDataPoints && this.zeroDataPoints.length > 0;
      },
    },
    methods: {
      prompt({ futureDataPoints = [], zeroDataPoints = [] }) {
        this.futureDataPoints = futureDataPoints;
        this.zeroDataPoints = zeroDataPoints;

        this.isShowing = true;

        return new Promise((resolve, reject) => {
          this.resolvePromise = resolve;
          this.rejectPromise = reject;
        });
      },
      __confirm() {
        this.isShowing = false;
        this.resolvePromise(true);
      },
      __reject() {
        this.isShowing = false;
        this.rejectPromise(true);
      },
      __cancel() {
        this.isShowing = false;
        this.resolvePromise(false);
      },
    },
  };
</script>

<style lang="scss" scoped>
  :deep(.base-modal__content) {
    overflow: hidden;
  }
  .bold {
    font-weight: 700;
  }
  .italic {
    font-style: italic;
  }
  .dataset-upload-warning-dialog {
    color: var(--itr-blue);

    &__title {
      margin: 10px 0;
      padding: 5px 0;
      font-weight: 700;
      font-size: 20px;
    }
    &__container {
      height: 100%;
      max-height: 80vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 0;
      margin: 0;
    }

    &__header {
      display: flex;
      justify-content: center;
      background-color: transparent;
      width: 100%;
      text-align: center;
    }
    &__body {
      flex: 1 auto;
      background-color: transparent;
      width: 100%;
      padding: 25px 0;
      overflow-y: auto;
    }
    &__footer {
      display: flex;
      justify-content: center;
      align-content: center;
      gap: 25px;

      background-color: transparent;
      padding: 15px;
      width: 100%;
    }

    &__button {
      padding: 10px 25px;
      border-radius: 6px;
      width: 100%;
      max-width: 225px;
      text-transform: uppercase;
      cursor: pointer;
      font-weight: 700;

      background-color: #cccccc;
      color: var(--itr-blue);

      &--confirm {
        background-color: var(--itr-green-mid);
        color: #f1f2f3;
      }
    }
  }
</style>
